import {peakAlert} from "../PeakDialog.js";
import jQuery from "jquery";
import {ZIDX} from "../standalone/standaloneLibrary.js";

let $=jQuery.noConflict();

export class ZIDXFileUploadProgress{
    formElement:HTMLFormElement;
    fieldInput:HTMLInputElement;
    previewDiv:HTMLDivElement;
    fileInput:HTMLInputElement;
    urlElement:HTMLInputElement;
    isImage:boolean;
    isUserTable:boolean;
    imageSizes:string;
    progressBar:HTMLProgressElement;
    zidx:ZIDX;
    constructor(formElement:HTMLFormElement, previewDiv:HTMLDivElement, fieldInput:HTMLInputElement, fileInput:HTMLInputElement, isImage:boolean, isUserTable:boolean, imageSizes:string, urlElement:HTMLInputElement, progressBar:HTMLProgressElement, zidx:ZIDX) {
        this.formElement=formElement;
        this.previewDiv=previewDiv;
        this.fieldInput=fieldInput;
        this.fileInput=fileInput;
        this.isImage=isImage;
        this.imageSizes=imageSizes;
        this.isUserTable=isUserTable;
        this.urlElement=urlElement;
        this.progressBar=progressBar;
        this.zidx=zidx;
    }
    doUpload() {
        let self = this;
        let formData = new FormData();
        if(!this.fileInput.files){
            console.log("No files to upload");
            return;
        }
        let fileUploadingField=<HTMLInputElement>this.zidx.peakidxShadowRoot.getElementById("fileUploadingField"+this.formElement.id);
        let uploading=parseInt(fileUploadingField.value);
        console.log("uploading value:", uploading, fileUploadingField, fileUploadingField.value);
        uploading++;
        fileUploadingField.value=uploading.toString();
        if(this.fileInput.multiple) {
            formData.append("multiple", "1");
        }else{
            formData.append("multiple", "0");
            self.previewDiv.innerHTML='';
        }
        for(let i=0;i<this.fileInput.files.length;i++){
            let currentFile:File=this.fileInput.files[i];
            let div=document.createElement("div");
            if(this.isImage) {
                div.className="zidxLocalPreviewImageContainer";
                let spinner=document.createElement("i");
                spinner.className="fa fa-refresh zidxLocalPreviewSpinner";
                spinner.setAttribute("aria-hidden", "true");
                div.appendChild(spinner);
                let img = document.createElement("img");
                img.setAttribute("style", "opacity:0.7; max-width:100%; max-height:100%;");
                // img.id="zidxPreviewImage"+(new Date().getTime());
                img.src = URL.createObjectURL(currentFile);
                img.onload = function () {
                    URL.revokeObjectURL(img.src) // free memory
                };
                div.appendChild(img);
            }else{
                div.className="zidxPreviewFileContainer";
                let span = document.createElement("span");
                span.innerText="Uploading File: "+currentFile.name;
                div.appendChild(span);
                let span2 = document.createElement("span");
                span2.setAttribute("style", "float:left;");
                let spinner=document.createElement("i");
                spinner.className="fa fa-refresh zidxPreviewSpinner";
                spinner.setAttribute("aria-hidden", "true");
                span2.appendChild(spinner);
                div.appendChild(span2);
            }
            self.previewDiv.innerHTML='';
            self.previewDiv.appendChild(div);
            // currentFile.type and currentFile.size also exist
            formData.append("files", currentFile, currentFile.name);
        }
        this.fileInput.value="";
        formData.append("previousIds", this.fieldInput.value);
        if(this.isUserTable) {
            formData.append("userTable", "1");
        }else{
            formData.append("userTable", "0");
        }
        formData.append("imageSizes", this.imageSizes);
        let client = new XMLHttpRequest();
        let url="/account/upload-file";
        if(this.isImage){
            url="/account/upload-image";
        }
        client.open("POST", url);
        client.upload.onprogress = function(pe) {
            if(pe.lengthComputable) {
                self.progressBar.max = pe.total;
                self.progressBar.value = pe.loaded;
                console.log('progress', pe.total, pe.loaded);
            }else{
                console.log("Can't compute upload progress");
            }
        }
        client.upload.onloadend = function(pe) {
            self.progressBar.style.display='none';
            console.log('upload complete', pe);
        }
        client.onloadend = function(pe) {
            self.progressBar.value = pe.loaded;
            let uploading=parseInt(fileUploadingField.value);
            uploading--;
            fileUploadingField.value=uploading.toString();
            let js:any=null;
            try{
                js=JSON.parse(this.responseText);
            }catch(e){
                js=null;
            }
            // console.log('response received', pe, this.responseText, js);
            if(!js || !js.success){
                peakAlert(js && js.errorMessage ? js.errorMessage : "Upload failed. Please try again.");
                $(".zidxLocalPreviewImageContainer", self.zidx.peakidxShadowRoot).detach();
                return;
            }
            let currentValue=self.fieldInput.value;
            let currentValueURL=self.urlElement.value;
            let fileData:any=null;
            try{
                fileData=JSON.parse(js.data);
            }catch(e){
                fileData=null;
            }
            if(!Array.isArray(fileData)){
                peakAlert("Upload failed. Please try again.");
                $(".zidxLocalPreviewImageContainer", self.zidx.peakidxShadowRoot).detach();
                return;
            }
            if(!self.fileInput.multiple) {
                currentValue="";
                currentValueURL="";
                self.previewDiv.innerHTML='';
            }
            $(".zidxLocalPreviewImageContainer", self.zidx.peakidxShadowRoot).detach();
            for(let i=0;i<fileData.length;i++){
                if(currentValue.length!=0) {
                    currentValue += ",";
                    currentValueURL += ",";
                }
                let container=document.createElement("div");
                if(self.isImage) {
                    container.className="zidxPreviewImageContainer";
                    let img=document.createElement("img");
                    img.src=fileData[i].link;
                    img.alt="Preview";
                    img.style.maxWidth="100%";
                    img.style.maxHeight="100%";
                    container.appendChild(img);
                }else{
                    container.className="zidxPreviewFileContainer";
                    let a=document.createElement("a");
                    a.href=fileData[i].link;
                    a.className="zidxManagerSearchButton";
                    a.target="_blank";
                    a.textContent='Download ('+fileData[i].name+')';
                    container.appendChild(a);
                }
                self.previewDiv.appendChild(container);
                currentValue+=fileData[i].id;
                currentValueURL+=fileData[i].link;
            }
            self.urlElement.value=currentValueURL;
            self.fieldInput.value=currentValue;
        }
        client.send(formData);
    }
}